import React from 'react'
import {
  format,
  eachWeekOfInterval,
  startOfWeek,
  subYears,
  addWeeks,
  previousMonday,
  lastDayOfYear,
  isSameYear,
  startOfYear,
  isMonday,
  nextMonday,
} from 'date-fns'
import { SelectBox } from 'components/formFields/SelectBox'

const getWeeks = (year: string, offsetWeeks?: number) => {
  if (!year) return []

  const today = new Date()
  const currentMonday = startOfWeek(today, { weekStartsOn: 1 })
  const prevMonday = previousMonday(currentMonday)

  const selectedYear = new Date(year)
  const selectedYearStart = startOfYear(selectedYear)
  const selectedYearEnd = lastDayOfYear(selectedYear)
  const yearStartMonday = isMonday(selectedYearStart) ? selectedYearStart : nextMonday(selectedYearStart)

  const twoYearsAgo = subYears(currentMonday, 2)
  const offsetMonday = offsetWeeks ? startOfWeek(addWeeks(twoYearsAgo, offsetWeeks), { weekStartsOn: 1 }) : undefined

  const yearStartDate = isSameYear(selectedYear, offsetMonday ?? twoYearsAgo)
    ? offsetMonday ?? twoYearsAgo
    : yearStartMonday
  const yearLastDate = isSameYear(selectedYear, today) ? (offsetMonday ? prevMonday : currentMonday) : selectedYearEnd

  const weeksDateArray = eachWeekOfInterval(
    {
      start: yearStartDate,
      end: yearLastDate,
    },
    { weekStartsOn: 1 }
  ).reverse()

  return weeksDateArray
}

type SelectWeekProps = {
  disabled?: boolean
  offsetWeeks?: number
  searchState: {
    year: string
    weekCommencing: string
  }
  handleWeekChange(selectedWeek: string): void
}

export const SelectWeek = (props: SelectWeekProps) => {
  const { disabled, offsetWeeks, searchState, handleWeekChange } = props
  const { weekCommencing, year } = searchState

  const isDisabled = !year || disabled

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (validation: boolean = false) => {
    if (!weekCommencing) {
      if (fieldError) return true
      else if (validation) setFieldError('triggered')
    }
    return false
  }

  return (
    <div className="w-full sm:w-64">
      <SelectBox
        placeholder="Select week start date"
        label="Week Commencing On *"
        id="week-commencing"
        value={weekCommencing}
        disabled={isDisabled}
        onChange={(value) => handleWeekChange(value)}
        options={getWeeks(year, offsetWeeks).map((item) => ({
          text: format(item, 'dd/MM/yy'),
          value: format(item, 'yyyy-MM-dd'),
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        enableSearch={true}
      />
    </div>
  )
}
